export enum HogaSuggestType {
    POSTAL_CODE = 'postalCode',
    CITY = 'city',
    STREET = 'street'
}

export class HogaRequest {
    type: HogaSuggestType;
    postalCode: string;
    city: string;
    street: string;

    constructor(type: HogaSuggestType, postalCode: string = null, city: string = null, street: string = null) {
        this.type = type;
        this.postalCode = postalCode;
        this.city = city;
        this.street = street;
    }
}
